import { NuvoList } from '@nuvolo/nuux-core/components/NuvoList';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React, { useCallback } from 'react';
import type { Asset, WorkOrderTemplate } from '#/graphql/types';
import If from '#/common/components/If';
import styled from 'styled-components';
import StandardThrobber from '../Throbbers/StandardThrobber';

export interface TemplatesListProps {
  loading: boolean;
  asset: Asset | undefined;
  templates: WorkOrderTemplate[];
  onSelect: (template: WorkOrderTemplate) => void;
}

const Styles = styled.div`
  .dx-list {
    margin: -4px;

    .dx-scrollview-content {
      padding: 4px;
    }
  }
`;

const TemplatesList: React.FC<TemplatesListProps> = ({ loading, asset, templates, onSelect }) => {
  const { height, size } = useViewport();
  const listHeight = Math.max(386, size === 'xs' ? height - 630 : height - 590);

  const onTemplateSelect = useCallback((t: WorkOrderTemplate[]) => onSelect(t[0]), [onSelect]);

  return (
    <>
      <If condition={loading}>
        <StandardThrobber />
      </If>
      <If condition={!loading}>
        <Styles>
          <NuvoList
            height={listHeight}
            dataSource={templates}
            includeImage={false}
            selectionMode="single"
            onSelectedItemsChange={onTemplateSelect}
            noDataText={asset ? 'No templates found' : 'Select an asset first'}
          />
        </Styles>
      </If>
    </>
  );
};

export default React.memo(TemplatesList);
